document.addEventListener('DOMContentLoaded', function () {

  // Sluit de Impact search-drawer als die toch opent
  const drawer = document.querySelector('[id="search-drawer"]');
  if (drawer) {
    const observer = new MutationObserver(function () {
      if (drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false') {
        drawer.removeAttribute('open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('aria-expanded', 'false');
      }
    });
    observer.observe(drawer, { attributes: true });
  }

  // Blokkeer form submit
  document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  });

});